export default __webpack_public_path__ + "static/slider-asiento-bus-0fedc8098038b7518299504256461214.png";